import { BackButton, NextButton } from '@/components/buttons/Buttons';
import Container, { Column, Row } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import RowCheckboxInput from '@/components/form-inputs/RowCheckboxInput';
import { TextBodyMedium, TextHeadlineExtraExtraLarge2, TextHeadlineLarge, TextLabelLarge, TextTitleLarge2 } from '@/components/text/Texts';
import { DELIVERY, MEALS, RIDE } from '@/constants/types-of-services';
import { ProgramRidePurpose, RIDE_PURPOSE } from '@/types';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { MdDirectionsCarFilled, MdOutlineInventory2, MdRestaurant } from 'react-icons/md';
import { OnBoardingStateProgramProps } from '../ChooseProgramWizard';
import { useAuthenticationStore } from '@/store';
import CheckboxInput from '@/components/form-inputs/CheckboxInput';
import { array, boolean, object, string } from 'yup';
import { VALIDATION_MESSAGES } from '@/constants/validation';
import { cn } from '@/components/ui/cn';
import { useEffect, useState } from 'react';
import DropdownInput from '@/components/inputs/DropdownInput';
import { InputController } from '@/components/inputs/InputController';
import MultiDropdownInput from '@/components/inputs/MultiDropdownInput';

const schema = object({
	RideOption: boolean().required(VALIDATION_MESSAGES.required).test('', '', (value) => value),
	RideEstimate: string().required(VALIDATION_MESSAGES.required),
	RidePurposes: array().min(1, VALIDATION_MESSAGES.required).required(),
});

interface ServicesForm {
	RideOption: boolean;
	// MealsOption: string;
	// DeliveryOption: string;
	RideEstimate: string;
	RidePurposes: Array<string>;
}

const ServicesToProvideForm = (props: OnBoardingStateProgramProps) => {
	// Programs are fake for now, so the form also. Andrew told somewhen this July that we need just UI. The only program we have de-facto for now is incorporated into the app logic.
	const form = useForm<ServicesForm>({
		resolver: yupResolver(schema),
		mode: 'all',
	});

	//set form
	useEffect(() => {
		if (props.isLoading || !props.onboardingProgram) return;

		const data = props.onboardingProgram;

		// If RidePerDay exists, set the form values
		if (data.RidePerDay) {
			form.setValue('RideOption', true, { shouldValidate: true });
			form.setValue('RideEstimate', data.RidePerDay, { shouldValidate: true });
		}

		// If Purposes exist, convert them to strings for the multiselect
		if (data.Purposes && data.Purposes.length > 0) {
			const purposeStrings = data.Purposes!.map(p => {
				const str = RIDE_PURPOSE.find(j => j.purposeId == p.Purpose)!.value;
				return str;
			});
			form.setValue('RidePurposes', purposeStrings, { shouldValidate: true });
		}
	}, [props.isLoading, props.onboardingProgram, form]);

	const { user } = useAuthenticationStore();

	const iconStyle = { size: 24, className: 'text-primary' };

	const options = [
		// {
		// 	id: RIDE,
		// 	name: RIDE,
		// 	icon: <MdDirectionsCarFilled {...iconStyle} />,
		// 	disabled: false
		// },
		{
			id: DELIVERY,
			name: DELIVERY,
			icon: <MdOutlineInventory2 {...iconStyle} />,
			disabled: false
		},
		{
			id: MEALS,
			name: MEALS,
			icon: <MdRestaurant {...iconStyle} />,
			disabled: true
		},
	];

	//const services = watch('services');

	// const onItemChange = useCallback(
	// 	(item: string) => {
	// 		setValue(
	// 			'services',
	// 			services.includes(item)
	// 				? services.filter((service) => service !== item)
	// 				: [...services, item],
	// 			{
	// 				shouldValidate: true,
	// 				shouldDirty: true,
	// 			},
	// 		);
	// 	},
	// 	[services, setValue],
	// );

	// useEffect(() => {
	// 	if (props.values?.services) {
	// 		setValue('services', props.values.services, {
	// 			shouldValidate: true,
	// 		});
	// 	}
	// }, [props.values, setValue]);

	const [selectedServices, setSelectedServices] = useState<string[]>([]);

	const toggleService = (id: string) => {
		setSelectedServices((prev) =>
			prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id],
		);
	};

	const rideOption = form.watch('RideOption');
	const rideFrequency = Array
		.from({ length: 10 }, (_, i) => `${i * 10 + 1}-${i * 10 + 10}`)
		.map(v => ({ label: v, value: v }));

	return (
		<Container>
			<Column className="mb-6 gap-2">
				<TextHeadlineExtraExtraLarge2
					text={`Welcome, ${user?.firstName}!`}
					className="text-neutral17"
				/>
				<TextBodyMedium
					text="Providing answers to these quick questions will assist us in tailoring your experience."
					className="text-neutral17"
				/>
			</Column>
			<Column className="mb-10 gap-2">
				<TextHeadlineLarge
					text="Which service are you interested in providing?"
					className="text-neutral17"
				/>
				<TextBodyMedium
					text="Choose one or more options for now. You can always add more options later."
					className="text-neutral17"
				/>
			</Column>

			<Column gap="gap-2 w-[976px] max-w-full tablet:w-full">
				{/* For Ride we not use RowCheckboxInput because of complexity added by figma design changes. Will see later if it needs refactoring.*/}
				<Container
					// onClick={toggle}
					// disabled={disabled}
					className={cn(
						'cursor-pointer active:bg-surfaceDimfocus-visible:outline-none focus-visible:bg-surfaceDim bg-surfaceBright rounded-[28px] p-[24px]',
						'duration-200',
						rideOption && 'shadow-[inset_0_0_0_2px_theme(colors.primary60)]',
					)}
					aria-label={RIDE}
				>
					<Column className="gap-6">
						<Row className="h-12 justify-between items-center">
							<Row className="gap-3">
								<MdDirectionsCarFilled {...iconStyle} />
								<TextLabelLarge text={RIDE} className="text-primary" />
							</Row>
							<CheckboxInput
								tabIndex={-1}
								id='RideOption'
								name='RideOption'
								text=""
								control={form.control}
								// value={RIDE}
								// onChange={() => onItemChange(RIDE)}
								// checked={services.includes(RIDE)}
								disabled={false}
							/>
						</Row>

						{rideOption && (
							<>
								<Column className="gap-2">
									<TextTitleLarge2
										text="On average, how many bookings do you anticipate per day?"
										className="text-neutral17"
									/>
									<TextBodyMedium
										text="Understanding daily bookings estimates helps us tailor our services to your needs and optimize your experience."
										className="text-neutral17"
									/>
								</Column>

								<Container className="grid sm:grid-cols-1 md:grid-cols-2 w-full gap-6">
									<InputController id="RideEstimate" control={form.control}>
										<DropdownInput
											label="Ride per day"
											placeholder="Please select"
											options={rideFrequency}
										/>
									</InputController>
									<InputController id="RidePurposes" control={form.control}>
										<MultiDropdownInput
											label="Purpose"
											placeholder="Please select"
											options={RIDE_PURPOSE}
										/>
									</InputController>
								</Container>
							</>
						)}

					</Column>
				</Container>

				{options.map((item) => {
					return (
						<RowCheckboxInput
							key={`${item.id}-input`}
							id={item.id}
							icon={item.icon}
							name={item.name}
							value={item.id}
							onChange={() => toggleService(item.id)}
							checked={selectedServices.includes(item.id)}
							disabled={item.disabled}
						/>
					);
				})}
			</Column>
			<Spacing height="h-[40px]" />
			<Container className="flex justify-between">
				{props.onBack ? (
					<BackButton
						withIcon={true}
						onClick={props.onBack}
						id="choose-program-back"
					/>
				) : (
					''
				)}
				<Container className="flex self-end justify-self-end">
					<NextButton
						withIcon={false}
						disabled={!form.formState.isValid}
						onClick={form.handleSubmit(() => {
							const ps = form.getValues().RidePurposes.map(i => {
								const rp = RIDE_PURPOSE.find(j => j.value == i);
								return { Purpose: rp?.purposeId } as ProgramRidePurpose;
							});
							props.onSubmit({
								RidePerDay: form.getValues().RideEstimate,
								Purposes: ps
								// serviceEstimates: [
								// 	{
								// 		type: EstimateType.RIDES,
								// 		value: form.getValues().RideEstimate,
								// 		purpose: form.getValues().RidePurposes
								// 	}
								// ]
							});
						})}
						id="choose-program-next"
					/>
				</Container>
			</Container>
		</Container>
	);
};

export default ServicesToProvideForm;
